<template>
  <div id="zt598bc">
    <div id="k1">
      <div>
        <label>ZT598BC</label>
        <label>PCI5.x安全认证，国密认证 </label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt598bc/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt598bc/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/zt598bc/icon.png')"/>
    </div>
    <div id="k3">
      <div>先进的技术</div>
      <div>支持远程密钥下载和远程固体升级</div>
    </div>
    <div id="k4">
      <div>产品尺寸</div>
      <div>USB2.0和RS-232接口</div>
    </div>
    <div id="k5">
      <h5>应用场景</h5>
      <div v-for="item in asdata" :key="item.label">
        <img :src="item.pic" />
        <label>{{item.label}}</label>
      </div>
    </div>

    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      asdata: [
        {
          label: 'ATM',
          pic: require('@/assets/pic/zt598bc/as1.jpg')
        },
        {
          label: '取票机',
          pic: require('@/assets/pic/zt598bc/as2.jpg')
        },
        {
          label: '自助服务机',
          pic: require('@/assets/pic/zt598bc/as3.jpg')
        }
      ],
      spdata: {
        file: 'zt598bc',
        data: [
          {label: '通讯接口', desc: ['USB-B接口×1'], pic: 'port.png'},
          {label: '输入电压', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: '按键数量', desc: ['数字按键×10', '功能按键×6'], pic: 'keyt.png'},
          {label: '可扩充性（选配）', desc: ['扩展功能键盘(扫描方式1×4)'], pic: 'expand.png'},
          {label: '按键字符', desc: ['采用高强度油墨制作', '可定制各种文字或符号'], pic: 'scchsize.png'},
          {label: '防水等级 level', desc: ['IP65(静态)/IP54（动态）'],pic: 'prtw.png'},
          {label: '符合标准', desc: ['ANSI X、ISO、IBM3624、GB/T 15277以及国密标准GM/T等'],pic: 'stdok.png'},
          {label: '保护能力', desc: ['停电敏感数据可保存5年以上'],pic: 'prtab.png'},
          {label: '功能支持', desc: ['PIN加密、MAC运算、数据加密/解密、远程密钥管理、远程固件更新'], pic: 'funsp.png'},
          {label: 'IK防护等级 level', desc: ['IK08'],pic: 'prtlv.png'},
          {label: 'EFT', desc: ['能通过重复频率100KHz，', '电压1.0KV抗干扰测试'],pic: 'eft.png'},
          {label: 'ESD', desc: ['可承受接触放电±6KV、', '空气放电±8KV的静电攻击'],pic: 'esd.png'},
          {label: '产品尺寸', desc: ['137mm×106mm×28.9mm'], pic: 'size.png'},
          {label: '按键材料', desc: ['SUS304不锈钢'], pic: 'keymt.png'},
          {label: '适用环境', desc: ['工作温度：-25℃～+60℃', '存储温度：-40℃～+70℃', '相对湿度：10%～93% RH (无凝结露)'], pic: 'env.png'},

        ]
      },
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt598bc {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598bc/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: .7rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.55rem;
  margin-left: 3.72rem;
  /* width: 4.138rem; */
  color: white;
}
#k1 label {
  display: block;
  font-size: .6rem;
  font-weight: bold;
}
#k1 label:nth-child(2) {
  font-size: .36rem !important;
  font-weight: 500 !important;
  margin-top: .05rem;
}


#k2 {
  background: #EEEEEE  ;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  /* line-height: 1.78rem !important; */
}

#k2 img {
  margin: .55rem auto;
  /* height: .8rem; */
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598bc/bg2.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k3 div:nth-child(1) {
  margin-top: 2.77rem;
  font-size: .58rem;
  font-weight: bold;
  color: #4C4D4C;
}
#k3 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.1rem;
  margin-top: .1rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt598bc/bg3.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 6rem;
  margin: .58rem auto;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.2rem;
  margin: -.45rem auto;
}

#k5 {
  height: 7rem;
  background:#FAFAFA ;
  text-align: center;
  overflow: hidden;
}
#k5 h5 {
  font-size: .6rem;
  font-weight: bold;
  color: #313333;
  margin: .75rem auto .52rem auto;
}
#k5 div {
  display: inline-block;
  margin: 0 .1rem 0 .1rem;
}
#k5 img {
  display: block;
  height: 2.62rem;
  margin-bottom: .34rem;
}
#k5 label {
  font-size: .32rem;
  font-weight: bold;
  color: #0080CC;
}




</style>
